module.exports = __webpack_public_path__ + "img/noble-level5-bg.ee374f9f.png";